import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Empresa from './Empresa';





interface EmpresaTableProps {
  data: Empresa[];
  columns: TableColumn<Empresa>[];
  customStyles: Record<string, any>;
}

const EmpresaTable: React.FC<EmpresaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Empresa>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default EmpresaTable;